module.exports = __webpack_public_path__ + "static/img/danshuierchang.cbd1d61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/danshuierchang.jpg
// module id = 1e9k
// module chunks = 1